module.exports = __webpack_public_path__ + "img/car-3.44c57cf4.jpg";